import { ITutorialPassos, MensagensPadrao } from '../../../Components/AdicionarAjuda';

export const IDs = {
    formularioDeFiltro: "formulario-de-filtros-do-responsavel",

    filtroDeCPF: "campo-cpf-filtros-do-responsavel",
    filtroDeNome: "campo-nome-filtros-do-responsavel",
    filtroDeDocumento: "campo-documento-filtros-do-responsavel",
    filtroDeTipoDeDocumento: "campo-tipo-documento-filtros-do-responsavel",
    filtroDeValorDoDocumento: "campo-valor-documento-filtros-do-responsavel",
    filtroDeAtivo: "campo-ativo-filtros-do-responsavel",

    botaoListar: "botao-listar-responsavel",
    botaoAdicionar: "botao-adicionar-responsavel",
}

export const Classes = {
    botaoEditar: "botao-editar-responsavel",
    botaoDesativar: "botao-desativar-responsavel",
}

export const ConsultarResponsavel: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.filtros.apresentacao, target: () => document.getElementById(IDs.formularioDeFiltro)! },
        { ...MensagensPadrao.filtros.cpf, target: () => document.getElementById(IDs.filtroDeCPF)! },
        { ...MensagensPadrao.filtros.nome, target: () => document.getElementById(IDs.filtroDeNome)! },
        {
            title: "Documento",
            description: <>É possível filtrar por outros documentos que estejam vinculado ao aluno</>,
            target: () => document.getElementById(IDs.filtroDeDocumento)!
        },
        {
            title: "Tipo de documento",
            description: <>Selecione o tipo de documento usando o menu</>,
            target: () => document.getElementById(IDs.filtroDeTipoDeDocumento)!
        },
        {
            title: "Valor",
            description: <>Em seguida, informe o valor desse documento</>,
            target: () => document.getElementById(IDs.filtroDeValorDoDocumento)!
        },
        { ...MensagensPadrao.filtros.ativo, target: () => document.getElementById(IDs.filtroDeAtivo)! },
        { ...MensagensPadrao.filtros.botaoListar, target: () => document.getElementById(IDs.botaoListar)! },
    ]
}

export const AdicionarResponsavel: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.adicionar.entrada, target: () => document.getElementById(IDs.botaoAdicionar)! },
    ]
}

export const EditarResponsavel: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.editar, target: () => document.querySelector("." + Classes.botaoEditar)! },
    ]
}

export const DesativarResponsavel: ITutorialPassos = {
    steps: [
        { ...MensagensPadrao.alterar.desativar, target: () => document.querySelector("." + Classes.botaoDesativar)! },
    ]
}
